'use strict';
/*
  tape — typewriter / documentary. Warm off-white monospace that types on letter
  by letter on a dark field, with a faint amber key word and a soft film grade.
  Restrained and literary — built for talking-head subtitles.
*/
const { FONTS } = require('../lib/draw');
const { layoutCue } = require('./_common');

const palette = { bg: '#0d0d0c', fg: '#ece7da', accent: '#ffb000', ink: '#0d0d0c' };

function init(st){ st.s.font = st.tk.registerFamily('ForgeMono', FONTS.mono) || undefined; }

function background(ctx, st){
  const { W, H } = st;
  if (!st.overlayMode) {
    const g = ctx.createLinearGradient(0, 0, 0, H);
    g.addColorStop(0, '#141312'); g.addColorStop(1, '#080807');
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  } else {
    const g = ctx.createLinearGradient(0, H * 0.5, 0, H);
    g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,0.55)');
    ctx.fillStyle = g; ctx.fillRect(0, H * 0.5, W, H * 0.5);
  }
}

function paintToken(ctx, o){
  const { T, cx, cy, px, scl, alpha, emph, st } = o, tk = st.tk;
  ctx.save(); ctx.globalAlpha = alpha; ctx.translate(cx, cy); ctx.scale(scl, scl);
  ctx.font = tk.font(px, 700, st.s.font); ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  ctx.shadowColor = 'rgba(0,0,0,0.6)'; ctx.shadowBlur = px * 0.10; ctx.shadowOffsetY = px * 0.02;
  ctx.lineJoin = 'round'; ctx.lineWidth = px * 0.10; ctx.strokeStyle = 'rgba(0,0,0,0.7)'; ctx.strokeText(T, 0, 0);
  ctx.shadowColor = 'transparent';
  ctx.fillStyle = emph ? palette.accent : palette.fg; ctx.fillText(T, 0, 0);
  ctx.restore();
}

function drawCue(ctx, st){
  const anchor = st.mode === 'talk' ? 0.76 : 'center';
  // per-letter reveal with the 'type' snap = words clatter on like a typewriter
  layoutCue(ctx, st, { sizes: { big: 96, mid: 84, small: 56 }, anchor, safeW: 0.86, reveal: 0.16, stagger: 0.06, perLetter: true, letterStagger: 0.02, trans: 0.14, family: st.s.font, paintToken });
}

function overlay(ctx, st){
  const tk = st.tk;
  ctx.save(); ctx.globalAlpha = 0.05; ctx.globalCompositeOperation = 'overlay'; ctx.drawImage(tk.grain(), -Math.random() * 100, -Math.random() * 100); ctx.restore();
  ctx.drawImage(tk.vignette(st.overlayMode ? 0.5 : 0.74, 320), 0, 0);
  if (!st.overlayMode) { ctx.fillStyle = palette.accent; ctx.fillRect(0, st.H - 5, st.W * st.progress, 5); }
}

module.exports = { id: 'tape', label: 'Typewriter · mono', palette, init, background, drawCue, overlay, paintToken };
